<template>
    <div style="background:#ffff;">
        <Card :bordered="false" style="padding: 0;">
            <div style=" display: flex; flex-direction: row;">
                <div style="width:100%; padding-top: 13px;">
                    <p style="font-size: 16px;">
                        <Icon type="ios-school" color="#f48b16e8" size="24" />&#160&#160{{ teacherInfo.staff_name || '机构管理员'
                        }}
                    </p>
                    <p style="padding-top: 11px;">
                        <Icon type="ios-stats" color="#f48b16e8" size="24" />&#160&#160{{ teacherInfo.store_name }}
                    </p>
                    <p style="width:51%;float: left;">
                        <Icon type="ios-pulse" color="#f48b16e8" size="24" />&#160&#160主教次数:&#160{{ teacherInfo.host_sgin ||
                            '0' }}
                    </p>
                    <p style="width:40%;float: left;">
                        <Icon type="ios-pulse-outline" color="#f48b16e8" size="24" />助教次数:&#160{{ teacherInfo.aid_sgin ||
                            '0'
                        }}
                    </p>
                </div>
                <div style="width:100px;"><img :src="teacherInfo.avatar"
                        style="width: 80px;margin-right: 6px;margin-top: 7px;border-radius: 50px;" />
                </div>
            </div>
            <div style="height: 20px;">
                <div style="width:100%;">
                </div>
            </div>
        </Card>
        <div style=";background: #d7e9fc;border-radius:25px;width: 100%;padding-top: 20px;">
            <Tabs :value="toWeek" style="border: none;background: #d7e9fc;border-radius:25px;width: 100%;">
                <TabPane label="日" :name="toWeek7" style="background:#eee;padding: 20px;background: #d7e9fc;">
                    <div style="background:#eee;padding: 20px;height: 100%;">
                        <Card :bordered="false" v-for="(item, index) in grade" :key="index" style="margin-bottom: 10px;">
                            <p slot="title" style="font-size: 15px;">
                                <Icon type="ios-easel-outline" color="#f48b16e8" size="23" />&#160&#160{{ item.gradeName }}
                            </p>
                            <p v-if="item.teacher">
                                <Icon type="ios-pulse" color="#f48b16e8" size="21" />&#160&#160主教老师:&#160&#160&#160{{
                                    item.teacher }}
                            </p>
                            <p v-if="item.teacherOther">
                                <Icon type="ios-pulse-outline" color="#f48b16e8" size="21" />
                                &#160&#160助教老师:&#160&#160&#160{{ item.teacherOther }}
                            </p>
                            <p>
                                <Icon type="md-speedometer" color="#f48b16e8" size="21" />&#160&#160上课时间&#160&#160&#160{{
                                    item.timeStart }}--{{ item.timeStop }}
                            </p>
                        </Card>
                    </div>
                </TabPane>
                <TabPane label="一" :name="toWeek1">
                    <div style="background:#eee;padding: 20px;height: 100%;">
                        <Card :bordered="false" v-for="(item, index) in grade1" :key="index" style="margin-bottom: 10px;">
                            <p slot="title" style="font-size: 15px;">
                                <Icon type="ios-easel-outline" color="#f48b16e8" size="23" />&#160&#160{{ item.gradeName }}
                            </p>
                            <p v-if="item.teacher">
                                <Icon type="ios-pulse" color="#f48b16e8" size="21" />&#160&#160主教老师:&#160&#160&#160{{
                                    item.teacher }}
                            </p>
                            <p v-if="item.teacherOther">
                                <Icon type="ios-pulse-outline" color="#f48b16e8" size="21" />
                                &#160&#160助教老师:&#160&#160&#160{{ item.teacherOther }}
                            </p>
                            <p>
                                <Icon type="md-speedometer" color="#f48b16e8" size="21" />&#160&#160上课时间&#160&#160&#160{{
                                    item.timeStart }}--{{ item.timeStop }}
                            </p>
                        </Card>
                    </div>
                </TabPane>
                <TabPane label="二" :name="toWeek2">
                    <div style="background:#eee;padding: 20px;height: 100%;">
                        <Card :bordered="false" v-for="(item, index) in grade2" :key="index" style="margin-bottom: 10px;">
                            <p slot="title" style="font-size: 15px;">
                                <Icon type="ios-easel-outline" color="#f48b16e8" size="23" />&#160&#160{{ item.gradeName }}
                            </p>
                            <p v-if="item.teacher">
                                <Icon type="ios-pulse" color="#f48b16e8" size="21" />&#160&#160主教老师:&#160&#160&#160{{
                                    item.teacher }}
                            </p>
                            <p v-if="item.teacherOther">
                                <Icon type="ios-pulse-outline" color="#f48b16e8" size="21" />
                                &#160&#160助教老师:&#160&#160&#160{{ item.teacherOther }}
                            </p>
                            <p>
                                <Icon type="md-speedometer" color="#f48b16e8" size="21" />&#160&#160上课时间&#160&#160&#160{{
                                    item.timeStart }}--{{ item.timeStop }}
                            </p>
                        </Card>
                    </div>
                </TabPane>
                <TabPane label="三" :name="toWeek3">
                    <div style="background:#eee;padding: 20px;height: 100%;">
                        <Card :bordered="false" v-for="(item, index) in grade3" :key="index" style="margin-bottom: 10px;">
                            <p slot="title" style="font-size: 15px;">
                                <Icon type="ios-easel-outline" color="#f48b16e8" size="23" />&#160&#160{{ item.gradeName }}
                            </p>
                            <p v-if="item.teacher">
                                <Icon type="ios-pulse" color="#f48b16e8" size="21" />&#160&#160主教老师:&#160&#160&#160{{
                                    item.teacher }}
                            </p>
                            <p v-if="item.teacherOther">
                                <Icon type="ios-pulse-outline" color="#f48b16e8" size="21" />
                                &#160&#160助教老师:&#160&#160&#160{{ item.teacherOther }}
                            </p>
                            <p>
                                <Icon type="md-speedometer" color="#f48b16e8" size="21" />&#160&#160上课时间&#160&#160&#160{{
                                    item.timeStart }}--{{ item.timeStop }}
                            </p>
                        </Card>
                    </div>
                </TabPane>
                <TabPane label="四" :name="toWeek4">
                    <div style="background:#eee;padding: 20px;height: 100%;">
                        <Card :bordered="false" v-for="(item, index) in grade4" :key="index" style="margin-bottom: 10px;">
                            <p slot="title" style="font-size: 15px;">
                                <Icon type="ios-easel-outline" color="#f48b16e8" size="23" />&#160&#160{{ item.gradeName }}
                            </p>
                            <p v-if="item.teacher">
                                <Icon type="ios-pulse" color="#f48b16e8" size="21" />&#160&#160主教老师:&#160&#160&#160{{
                                    item.teacher }}
                            </p>
                            <p v-if="item.teacherOther">
                                <Icon type="ios-pulse-outline" color="#f48b16e8" size="21" />
                                &#160&#160助教老师:&#160&#160&#160{{ item.teacherOther }}
                            </p>
                            <p>
                                <Icon type="md-speedometer" color="#f48b16e8" size="21" />&#160&#160上课时间&#160&#160&#160{{
                                    item.timeStart }}--{{ item.timeStop }}
                            </p>
                        </Card>
                    </div>
                </TabPane>
                <TabPane label="五" :name="toWeek5">
                    <div style="background:#eee;padding: 20px;height: 100%;">
                        <Card :bordered="false" v-for="(item, index) in grade5" :key="index" style="margin-bottom: 10px;">
                            <p slot="title" style="font-size: 15px;">
                                <Icon type="ios-easel-outline" color="#f48b16e8" size="23" />&#160&#160{{ item.gradeName }}
                            </p>
                            <p v-if="item.teacher">
                                <Icon type="ios-pulse" color="#f48b16e8" size="21" />&#160&#160主教老师:&#160&#160&#160{{
                                    item.teacher }}
                            </p>
                            <p v-if="item.teacherOther">
                                <Icon type="ios-pulse-outline" color="#f48b16e8" size="21" />
                                &#160&#160助教老师:&#160&#160&#160{{ item.teacherOther }}
                            </p>
                            <p>
                                <Icon type="md-speedometer" color="#f48b16e8" size="21" />&#160&#160上课时间&#160&#160&#160{{
                                    item.timeStart }}--{{ item.timeStop }}
                            </p>
                        </Card>
                    </div>
                </TabPane>
                <TabPane label="六" :name="toWeek6">
                    <div style="background:#eee;padding: 20px;height: 100%;">
                        <Card :bordered="false" v-for="(item, index) in grade6" :key="index" style="margin-bottom: 10px;">
                            <p slot="title" style="font-size: 15px;">
                                <Icon type="ios-easel-outline" color="#f48b16e8" size="23" />&#160&#160{{ item.gradeName }}
                            </p>
                            <p v-if="item.teacher">
                                <Icon type="ios-pulse" color="#f48b16e8" size="21" />&#160&#160主教老师:&#160&#160&#160{{
                                    item.teacher }}
                            </p>
                            <p v-if="item.teacherOther">
                                <Icon type="ios-pulse-outline" color="#f48b16e8" size="21" />
                                &#160&#160助教老师:&#160&#160&#160{{ item.teacherOther }}
                            </p>
                            <p>
                                <Icon type="md-speedometer" color="#f48b16e8" size="21" />&#160&#160上课时间:&#160&#160&#160{{
                                    item.timeStart }}--{{ item.timeStop }}
                            </p>
                        </Card>
                    </div>
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>

  
<style scoped></style>
  
<script>
import { getUser, getteacherinfo, gradeLessonTime } from "@api/user";
import { addZoo, getWeek } from '@common'
export default {
    name: "Teacher",
    data: function () {
        return {
            userInfo: {},
            teacherInfo: {},
            toWeek: getWeek(Date.now()),
            toWeek1: getWeek(1692020377000),
            toWeek2: getWeek(1692106777000),
            toWeek3: getWeek(1692193177000),
            toWeek4: getWeek(1692279577000),
            toWeek5: getWeek(1692365977000),
            toWeek6: getWeek(1692452788000),
            toWeek7: getWeek(1692539188000),
            host: [],
            grade: [],
            grade1: [],
            grade2: [],
            grade3: [],
            grade4: [],
            grade5: [],
            grade6: [],
        };
    },
    methods: {
        User: function () {
            let that = this;
            getUser().then(res => {
                that.userInfo = res.data;
                var uid = that.userInfo.uid;
                getteacherinfo(uid).then(res => {
                    this.teacherInfo = res.data.data.teacherInfo;
                    gradeLessonTime().then(res => {
                        var teacherlessonInfo1 = res.data[1];
                        var teacherlessonInfo2 = res.data[2];
                        var teacherlessonInfo3 = res.data[3];
                        var teacherlessonInfo4 = res.data[4];
                        var teacherlessonInfo5 = res.data[5];
                        var teacherlessonInfo6 = res.data[6];
                        var teacherlessonInfo7 = res.data[7];
                        var userteacher = [];
                        var userteacher1 = [];
                        var userteacher2 = [];
                        var userteacher3 = [];
                        var userteacher4 = [];
                        var userteacher5 = [];
                        var userteacher6 = [];
                        for (let item of teacherlessonInfo1) {
                            if (item.teacher_id == this.teacherInfo.id || item.thr_one_id == this.teacherInfo.id) {
                                userteacher.push({
                                    gradeName: item.lesson,
                                    teacher: item.teacher,
                                    teacherOther: item.teacher_one,
                                    timeStart: `${addZoo(new Date(Number(item.start_time + '000')).getHours())}:${addZoo(new Date(Number(item.start_time + '000')).getMinutes())}`,
                                    timeStop: `${addZoo(new Date(Number(item.stop_time + '000')).getHours())}:${addZoo(new Date(Number(item.stop_time + '000')).getMinutes())}`,
                                });
                            } else if (that.userInfo.adminid) {
                                userteacher.push({
                                    gradeName: item.lesson,
                                    teacher: item.teacher,
                                    teacherOther: item.teacher_one,
                                    timeStart: `${addZoo(new Date(Number(item.start_time + '000')).getHours())}:${addZoo(new Date(Number(item.start_time + '000')).getMinutes())}`,
                                    timeStop: `${addZoo(new Date(Number(item.stop_time + '000')).getHours())}:${addZoo(new Date(Number(item.stop_time + '000')).getMinutes())}`,
                                });
                            }
                        }
                        for (let item of teacherlessonInfo2) {
                            if (item.teacher_id == this.teacherInfo.id || item.thr_one_id == this.teacherInfo.id) {
                                userteacher1.push({
                                    gradeName: item.lesson,
                                    teacher: item.teacher,
                                    teacherOther: item.teacher_one,
                                    timeStart: `${addZoo(new Date(Number(item.start_time + '000')).getHours())}:${addZoo(new Date(Number(item.start_time + '000')).getMinutes())}`,
                                    timeStop: `${addZoo(new Date(Number(item.stop_time + '000')).getHours())}:${addZoo(new Date(Number(item.stop_time + '000')).getMinutes())}`,
                                });
                            } else if (that.userInfo.adminid) {
                                userteacher1.push({
                                    gradeName: item.lesson,
                                    teacher: item.teacher,
                                    teacherOther: item.teacher_one,
                                    timeStart: `${addZoo(new Date(Number(item.start_time + '000')).getHours())}:${addZoo(new Date(Number(item.start_time + '000')).getMinutes())}`,
                                    timeStop: `${addZoo(new Date(Number(item.stop_time + '000')).getHours())}:${addZoo(new Date(Number(item.stop_time + '000')).getMinutes())}`,
                                });
                            }
                        }
                        for (let item of teacherlessonInfo3) {
                            if (item.teacher_id == this.teacherInfo.id || item.thr_one_id == this.teacherInfo.id) {
                                userteacher2.push({
                                    gradeName: item.lesson,
                                    teacher: item.teacher,
                                    teacherOther: item.teacher_one,
                                    timeStart: `${addZoo(new Date(Number(item.start_time + '000')).getHours())}:${addZoo(new Date(Number(item.start_time + '000')).getMinutes())}`,
                                    timeStop: `${addZoo(new Date(Number(item.stop_time + '000')).getHours())}:${addZoo(new Date(Number(item.stop_time + '000')).getMinutes())}`,
                                });
                            } else if (that.userInfo.adminid) {
                                userteacher2.push({
                                    gradeName: item.lesson,
                                    teacher: item.teacher,
                                    teacherOther: item.teacher_one,
                                    timeStart: `${addZoo(new Date(Number(item.start_time + '000')).getHours())}:${addZoo(new Date(Number(item.start_time + '000')).getMinutes())}`,
                                    timeStop: `${addZoo(new Date(Number(item.stop_time + '000')).getHours())}:${addZoo(new Date(Number(item.stop_time + '000')).getMinutes())}`,
                                });
                            }
                        }
                        for (let item of teacherlessonInfo4) {
                            if (item.teacher_id == this.teacherInfo.id || item.thr_one_id == this.teacherInfo.id) {
                                userteacher3.push({
                                    gradeName: item.lesson,
                                    teacher: item.teacher,
                                    teacherOther: item.teacher_one,
                                    timeStart: `${addZoo(new Date(Number(item.start_time + '000')).getHours())}:${addZoo(new Date(Number(item.start_time + '000')).getMinutes())}`,
                                    timeStop: `${addZoo(new Date(Number(item.stop_time + '000')).getHours())}:${addZoo(new Date(Number(item.stop_time + '000')).getMinutes())}`,
                                });
                            } else if (that.userInfo.adminid) {
                                userteacher3.push({
                                    gradeName: item.lesson,
                                    teacher: item.teacher,
                                    teacherOther: item.teacher_one,
                                    timeStart: `${addZoo(new Date(Number(item.start_time + '000')).getHours())}:${addZoo(new Date(Number(item.start_time + '000')).getMinutes())}`,
                                    timeStop: `${addZoo(new Date(Number(item.stop_time + '000')).getHours())}:${addZoo(new Date(Number(item.stop_time + '000')).getMinutes())}`,
                                });
                            }
                        }
                        for (let item of teacherlessonInfo5) {
                            if (item.teacher_id == this.teacherInfo.id || item.thr_one_id == this.teacherInfo.id) {
                                userteacher4.push({
                                    gradeName: item.lesson,
                                    teacher: item.teacher,
                                    teacherOther: item.teacher_one,
                                    timeStart: `${addZoo(new Date(Number(item.start_time + '000')).getHours())}:${addZoo(new Date(Number(item.start_time + '000')).getMinutes())}`,
                                    timeStop: `${addZoo(new Date(Number(item.stop_time + '000')).getHours())}:${addZoo(new Date(Number(item.stop_time + '000')).getMinutes())}`,
                                });
                            } else if (that.userInfo.adminid) {
                                userteacher4.push({
                                    gradeName: item.lesson,
                                    teacher: item.teacher,
                                    teacherOther: item.teacher_one,
                                    timeStart: `${addZoo(new Date(Number(item.start_time + '000')).getHours())}:${addZoo(new Date(Number(item.start_time + '000')).getMinutes())}`,
                                    timeStop: `${addZoo(new Date(Number(item.stop_time + '000')).getHours())}:${addZoo(new Date(Number(item.stop_time + '000')).getMinutes())}`,
                                });
                            }
                        }
                        for (let item of teacherlessonInfo6) {
                            if (item.teacher_id == this.teacherInfo.id || item.thr_one_id == this.teacherInfo.id) {
                                userteacher5.push({
                                    gradeName: item.lesson,
                                    teacher: item.teacher,
                                    teacherOther: item.teacher_one,
                                    timeStart: `${addZoo(new Date(Number(item.start_time + '000')).getHours())}:${addZoo(new Date(Number(item.start_time + '000')).getMinutes())}`,
                                    timeStop: `${addZoo(new Date(Number(item.stop_time + '000')).getHours())}:${addZoo(new Date(Number(item.stop_time + '000')).getMinutes())}`,
                                });
                            } else if (that.userInfo.adminid) {
                                userteacher5.push({
                                    gradeName: item.lesson,
                                    teacher: item.teacher,
                                    teacherOther: item.teacher_one,
                                    timeStart: `${addZoo(new Date(Number(item.start_time + '000')).getHours())}:${addZoo(new Date(Number(item.start_time + '000')).getMinutes())}`,
                                    timeStop: `${addZoo(new Date(Number(item.stop_time + '000')).getHours())}:${addZoo(new Date(Number(item.stop_time + '000')).getMinutes())}`,
                                });
                            }
                        }
                        for (let item of teacherlessonInfo7) {
                            if (item.teacher_id == this.teacherInfo.id || item.thr_one_id == this.teacherInfo.id) {
                                userteacher6.push({
                                    gradeName: item.lesson,
                                    teacher: item.teacher,
                                    teacherOther: item.teacher_one,
                                    timeStart: `${addZoo(new Date(Number(item.start_time + '000')).getHours())}:${addZoo(new Date(Number(item.start_time + '000')).getMinutes())}`,
                                    timeStop: `${addZoo(new Date(Number(item.stop_time + '000')).getHours())}:${addZoo(new Date(Number(item.stop_time + '000')).getMinutes())}`,
                                });
                            } else if (that.userInfo.adminid) {
                                userteacher6.push({
                                    gradeName: item.lesson,
                                    teacher: item.teacher,
                                    teacherOther: item.teacher_one,
                                    timeStart: `${addZoo(new Date(Number(item.start_time + '000')).getHours())}:${addZoo(new Date(Number(item.start_time + '000')).getMinutes())}`,
                                    timeStop: `${addZoo(new Date(Number(item.stop_time + '000')).getHours())}:${addZoo(new Date(Number(item.stop_time + '000')).getMinutes())}`,
                                });
                            }
                        }
                        this.grade = userteacher;
                        this.grade1 = userteacher1;
                        this.grade2 = userteacher2;
                        this.grade3 = userteacher3;
                        this.grade4 = userteacher4;
                        this.grade5 = userteacher5;
                        this.grade6 = userteacher6;
                    })
                });
            });
        },
    },
    mounted: function () {
        this.User();
    },
    watch: {
    }
};   
</script>
  